module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/hx.d4497a03.png";